export default {
  general: {
    showSoldSlides: false,
    showLayoutSwitchToggle: true,
    appResetTimeoutMinutes: 15,
  },
  filter: {
    enabled: false,
  },
};
